import { render, staticRenderFns } from "./FileChooser.vue?vue&type=template&id=edc9b60e"
import script from "./FileChooser.vue?vue&type=script&lang=js"
export * from "./FileChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports